import React from 'react';
import { useGetBrokerGroupDetailsQuery } from '@/features/user/userApi';
import { Typography } from '@mui/material';

const DataGridBrokerGroup = ({ row }) => {
	const { data: brokerGroup } = useGetBrokerGroupDetailsQuery(
		{ docId: row?.brokerGroupId },
		{ skip: !row?.brokerGroupId },
	);
	const branchName = brokerGroup?.name ?? '-';
	return <Typography variant='inherit'>{branchName}</Typography>;
};

export default DataGridBrokerGroup;
